/* eslint-disable no-mixed-operators */

import moment from 'moment';

export function createGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
            var r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
}

export function formatMoney(amount, currency) {
    if (!amount) amount = 0;
    if (!currency) currency = 'USD';

    return amount.toLocaleString(undefined, {
        style: 'currency',
        currency: currency,
    });
}

export function formatDate(date) {
    return new moment(date).format('MM/DD/YYYY');
}
